// extracted by mini-css-extract-plugin
export default {"not-found":"NotFoundPage_not-found__RT49n"};